import type { EngineDocument } from "../scene/model";
import { textData, textFont, characterStyle } from "../native/text";
import { isInteractive } from "../native/interactive";
export async function prepareFonts(document: EngineDocument) {
  const fonts = new Set<string>();
  for (const n of document.pages.flatMap((p) => p.nodes)) {
    if (n.kind === "text") {
      const t = textData(n);
      fonts.add(textFont(t));
      for (const key of Object.keys(t.styles))
        fonts.add(textFont(characterStyle(t, Number(key))));
    } else if (isInteractive(n)) {
      fonts.add(
        `${n.interaction.fontSize}px ${JSON.stringify(n.interaction.fontFamily)}`,
      );
    }
  }
  await Promise.all(
    [...fonts].map((font) => globalThis.document.fonts.load(font)),
  );
}
